<template>
  <v-row justify="center">
    <v-dialog v-model="isOpen" scrollable persistent max-width="750px">
      <v-form
        class="multi-form"
        ref="form"
        v-model="valid"
        v-on:submit.prevent="validate"
      >
        <v-card>
          <v-toolbar flat dark color="rgb(51, 97, 137)">
            <v-toolbar-title>
              <v-icon left>mdi-puzzle</v-icon
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.insertGame.addGame'
                )
              }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  dark
                  :disabled="loading"
                  @click="closeDialogQuestion"
                  v-on="on"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span class="subtitle-1">{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.close'
                )
              }}</span>
            </v-tooltip>
          </v-toolbar>

          <v-card-text>
            <v-row>
              <v-col cols="12">
                <p class="title">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertGame.typeGame'
                    )
                  }}
                </p>

                <v-radio-group
                  class="mt-0"
                  hide-details
                  v-model="gameType"
                  mandatory
                  row
                  :disabled="dialogMode == 'edit'"
                >
                  <v-radio
                    :label="
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertGame.MemoryGame'
                      )
                    "
                    :value="'memorygame'"
                  ></v-radio>
                  <v-radio
                    :label="
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertGame.CrosswordPuzzle'
                      )
                    "
                    :value="'crossword'"
                  ></v-radio>
                  <v-radio
                    :label="
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertGame.WordSearchPuzzle'
                      )
                    "
                    :value="'wordsearch'"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <p class="title">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertGame.question'
                    )
                  }}
                  <span class="red--text">*</span>
                </p>

                <quill-editor
                  class="editor"
                  ref="description"
                  v-model="question"
                  :rules="questionRules"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <div class="d-flex mb-2">
                  <p class="title">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertGame.addVoiceOpt'
                      )
                    }}
                  </p>
                </div>
                <!-- <div class="upload-btn-wrapper">
                  <button class="btn-choose body-1 font-weight-medium">
                    <v-icon>mdi-upload</v-icon>Upload audio
                  </button>
                  <input
                    type="file"
                    name="myfile"
                    @change="preview"
                    accept="image/png, image/jpeg, image/bmp"
                  />
                </div>-->

                <v-card height="100" outlined v-if="audio_id === null">
                  <div class="text-center center-panel">
                    <v-btn
                      outlined
                      color="blue-grey"
                      @click="openMediaDialog('audio')"
                    >
                      <v-icon left>mdi-volume-high</v-icon
                      >{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertExam.insertGame.addVoice'
                        )
                      }}
                    </v-btn>
                  </div>
                </v-card>
                <v-card height="85%" v-if="audio_id" outlined>
                  <v-row>
                    <v-col class="text-right">
                      <v-btn
                        elevation="0"
                        class="mb-0 body-2 error--text text-capitalize"
                        color="white"
                        v-if="audio_id"
                        @click="deletemedia('audio')"
                      >
                        <p class="mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.delete'
                            )
                          }}
                        </p>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="px-5">
                      <vuetify-audio
                        :file="audio_url"
                        :audioPlaying.sync="audioPlaying"
                      ></vuetify-audio>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
              <v-col cols="6">
                <div class="d-flex mb-2">
                  <p class="title">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertGame.addVdoOpt'
                      )
                    }}
                  </p>
                </div>
                <v-card height="100" outlined v-if="video_id === null">
                  <div class="text-center center-panel">
                    <v-btn
                      outlined
                      color="blue-grey"
                      @click="openMediaDialog('video')"
                    >
                      <v-icon left>mdi-video</v-icon
                      >{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertExam.insertGame.addVdo'
                        )
                      }}
                    </v-btn>
                  </div>
                </v-card>
                <v-card height="85%" outlined v-if="video_id">
                  <v-row>
                    <v-col class="text-right">
                      <v-btn
                        elevation="0"
                        class="mb-0 body-2 error--text text-capitalize"
                        color="white"
                        v-if="video_id"
                        @click="deletemedia('video')"
                      >
                        <p class="mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.delete'
                            )
                          }}
                        </p>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="px-5">
                      <div class="videoPlayer ma-auto">
                        <video-player
                          class="video-player-box videoContainer"
                          ref="videoPlayer"
                          :options="playerOptions"
                          :playsinline="true"
                          customEventName="customstatechangedeventname"
                          @ready="playerReadied"
                        ></video-player>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <div>
              <component
                ref="gameMaker"
                :is="currentGameMaker"
                :options="makerOptions"
                :answer-length.sync="answerLength"
                :game-body="gameBody"
                @onGameReady="onGameReady"
              ></component>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
              outlined
              :disabled="loading"
              @click="closeDialogQuestion"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.cancel'
                )
              }}</v-btn
            >
            <v-btn
              depressed
              class="px-10 ma-2 subtitle-2 button-primary font-weight-light text-capitalize white--text"
              @click="saveGameData"
              :loading="loading"
              :disabled="!validationForm() || loading"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.save'
                )
              }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="dialogSaveFail" persistent max-width="450" color="white">
      <v-card class="pa-3">
        <v-card-title class="mb-3">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.savingFailed'
          )
        }}</v-card-title>
        <v-card-text>
          <p class="subtitle-1">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.saveFailMsg'
              )
            }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="dialogSaveFail = false"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.confirm')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="warnningToSaveDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.alertLeavePageTitle'
            )
          }}
        </v-card-title>
        <v-card-text>
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.alertLeavePageSubTitle'
            )
          }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-capitalize"
            color="white"
            @click="warnningToSaveDialog = false"
          >
            <p class="mb-0">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertYoutube.continue'
                )
              }}
            </p>
          </v-btn>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="confirmCloseDialog()"
          >
            <p class="mb-0">
              {{
                $vuetify.lang.t('$vuetify.courseManagement.lectureStep.exit')
              }}
            </p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.saveDone'
          )
        }}</v-card-title>

        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.saveDoneDetail'
          )
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialogSuccess = false">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.done'
            )
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <insert-media-dialog
      :isMediaOpen.sync="mediaDialog"
      :isMediaClose="closeMediaDialog"
      :on-set-video="setVideo"
      :on-set-audio="setAudio"
      :typeMedia.sync="mediaType"
    ></insert-media-dialog>
  </v-row>
</template>

<script>
import 'video.js/dist/video-js.css';
import { videoPlayer } from 'vue-video-player';
import memoryGameMaker from '@/components/games/memoryGame.vue';
import crosswordPuzzleMaker from '@/components/games/crosswordPuzzle.vue';
import wordSearchPuzzleMaker from '@/components/games/wordSearchPuzzle.vue';

import {
  insertChoice,
  updateChoice,
  insertQuestion,
  getQuestionById,
  updateQuestion,
} from '@/service/course/exam';

import insertMediaDialog from '@/views/course/dialog/insertMediaDialog.vue';
import { headersWithTokenForImage, domain } from '@/service/configApi';
import { getPrivateImage } from '@/service/upload/upload.js';
import { serverName } from '@/service/configApi';
import { getPrivateVideo } from '@/service/upload/upload.js';

import videojs from 'video.js';
window.videojs = videojs;
import $ from 'jquery';
import { getPrivateFile } from '@/service/upload/upload.js';
import axios from 'axios';

// hls plugin for videojs6
require('videojs-contrib-hls/dist/videojs-contrib-hls.js');
export default {
  // el: "#row_answer",
  props: {
    isLectureOpen: {
      type: Boolean,
    },
    isOpen: {
      type: Boolean,
    },
    examId: {
      type: String,
    },
    randomChoice: {
      type: Boolean,
    },
    examFormat: {
      type: String,
    },
    questionId: {
      type: String,
    },
    questionType: {
      type: String,
    },
    articleId: {
      type: String,
    },
    lectureId: {
      type: String,
    },
    lectures: {
      type: Array,
    },
    sectionId: {
      type: String,
    },
    reorderLecture: {
      type: Function,
    },
    gameOptions: {
      type: Object,
    },
  },
  data() {
    return {
      gameReady: false,
      gameBody: {},
      tableSize: 8,
      gameType: 'memorygame',
      setRandomChoice: true,
      valid: true,
      dialog: false,
      dialog_1: false,
      notifications: false,
      sound: true,
      widgets: false,
      question: '',
      question_score: '',
      answer: [
        {
          text: '',
        },
      ],
      answerLength: 0,
      answer_description: '',
      // nameRules: [v => !!v || "กรุณากรอกคะแนน"],
      rows: [1],
      chars: null,
      answer_select: 0,
      answer_correct: 0,
      questionRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.questionRules'
          ),
      ],
      answerDescriptionRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.answerDescriptionRules'
          ),
      ],
      scoreRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.scoreRules'
          ),
      ],

      // audio
      audio_url: '',

      // mediaDialog
      mediaDialog: false,
      audio_id: null,
      video_id: null,

      playerOptions: {
        // videojs options
        fluid: true,
        height: '500',
        muted: true,
        hls: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: 'application/x-mpegURL',
            src:
              'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm',
          },
        ],
      },
      successUpload: false,
      isCheckComplete: false,
      urlVideo:
        'http://deknerdteam-09uxa0.cdn.byteark.com/videos/playlist.m3u8',
      cantGetLink: false,
      showUploadPercent: false,
      mediaType: '',
      audioPlaying: false,
      dialogMode: 'add',
      loading: false,
      dialogSaveFail: false,
      warnningToSaveDialog: false,
      dialogSuccess: false,
    };
  },
  components: {
    insertMediaDialog,
    // VuetifyAudio: () => import("vuetify-audio"),
    VuetifyAudio: () => import('@/components/vuetify-audio'),
    videoPlayer,
    memoryGameMaker,
    crosswordPuzzleMaker,
    wordSearchPuzzleMaker,
  },
  watch: {
    gameType() {
      // this.answer = [];
      // this.$nextTick(() => {
      //   this.$refs.gameMaker.init();
      // });
      this.gameReady = false;
    },
    answerLength(val) {
      this.validationForm();
    },
    isOpen: async function (newValue) {
      this.gameType = null;
      this.gameBody = {};

      if (newValue) {
        if (this.questionId) {
          this.gameType = this.gameOptions.type;
          // edit mode
          // let filterQuestion = this.questions.filter(
          //   question => question._id === this.questionId
          // )[0];
          // console.log(filterQuestion)
          let result = await getQuestionById({ id: this.questionId });
          this.oldQuestion = result;
          this.question = result.question;
          this.question_score = result.score;
          // this.answer = result.choices;
          // this.answer_description = result.note;
          // this.setRandomChoice = result.randomChoice;
          this.audio_id = result.audio;
          this.video_id = result.video;

          this.audio_id ? this.getAudioPreview() : '';
          this.video_id ? this.getPreview('video') : '';
          if (this.examFormat == 'english') {
            this.chars = 'abcdefghijklmnopqrstuvwxyz'.split('');
          } else if (this.examFormat == 'thai') {
            this.chars = 'กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรลวศษสหฬอฮ'.split(
              ''
            );
          } else {
            this.chars = null;
          }

          // this.answer_select = result.choices.map( choice=> choice._id === )
          if (
            result.typeQuestion != 'memorygame' &&
            result.typeQuestion != 'crossword' &&
            result.typeQuestion != 'wordsearch'
          ) {
            this.answer_correct = result.correct.map((correct) =>
              result.choices.findIndex((choices) => choices._id === correct._id)
            )[0];
          }

          // generate game body
          // console.clear();
          this.gameBody = {
            isRandom: result.randomChoice,
            randomLimit: result.randomLimit || 0,
            puzzleGridSize: result.puzzleGridSize,
            config: null,
            score: result.score || 0,
          };
          if (result.typeQuestion == 'memorygame') {
            //#region memory game
            this.gameBody.config = [];
            for (let choice of result.choices) {
              let newChoice = {
                _id: choice._id,
                imgs: [],
                single: choice.memory_game.single,
                score: choice.memory_game.score,
              };
              for (let img of choice.memory_game.images) {
                let urlPath = await getPrivateImage(img);
                newChoice.imgs.push({
                  _id: img,
                  file: null,
                  dataUrl: urlPath,
                });
              }

              this.gameBody.config.push(newChoice);
            }
            //#endregion
          } else {
            // crossword game and wordsearch
            let wordList = result.correctPuzzleGrid || [];
            let config = {
              wordList: wordList,
              letterTable: result.questionGrid,
            };
            this.gameBody.arrayScore = result.arrayScore;
            this.gameBody.config = config;
          }
          this.dialogMode = 'edit';
          this.$nextTick(() => {
            this.$refs.gameMaker.startup(true);
          });
          console.clear();
          // console.log(this.gameBody);
        } else {
          this.gameType = 'memorygame';
          // new mode
          this.valid = true;
          this.dialog_1 = false;
          this.question = '';
          this.question_score = '';
          this.answer_description = '';
          this.setRandomChoice = false;
          this.answer = [
            {
              text: '',
            },
          ];
          if (this.examFormat == 'english') {
            this.chars = 'abcdefghijklmnopqrstuvwxyz'.split('');
          } else if (this.examFormat == 'thai') {
            this.chars = 'กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรลวศษสหฬอฮ'.split(
              ''
            );
          } else {
            this.chars = null;
          }
          this.oldQuestion = {};
          this.answer_select = [];
          // this.$refs.form.reset();
          this.$refs.form.resetValidation();
          this.answer_correct = 0;
          this.audio_id = null;
          this.video_id = null;
          // console.log("this.answer_correct", this.answer, this.answer_correct);

          this.gameBody = {
            isRandom: true,
            randomLimit: 0,
            puzzleGridSize: 10,
            score: 0,
            config: null,
            arrayScore: [],
          };
          if (this.gameType == 'memorygame') {
            this.gameBody.isRandom = false;
            this.gameBody.config = [];
          } else {
            this.gameBody.config = {
              wordList: [],
              letterTable: [],
            };
          }
          this.dialogMode = 'add';

          this.$nextTick(() => {
            this.$refs.gameMaker.startup();
          });

          console.clear();
          // console.log(this.gameBody);
        }
      } else {
        // console.log("close", newValue);
        try {
          // console.log($("#videoPlayer")[0]);
          // $(".videoPlayer")[0].player.pause();
          $('video').each(function () {
            $(this).get(0).pause();
          });
        } catch (error) {
          console.log(error);
        }
        try {
          this.audio_url = '';
          this.audioPlaying = false;
          // $('#player')[0].pause();
          // $('#player')[0].currentTime = 0;
        } catch (error) {
          console.log(error);
        }
      }

      if (this.examFormat == 'english') {
        this.chars = 'abcdefghijklmnopqrstuvwxyz'.split('');
      } else if (this.examFormat == 'thai') {
        this.chars = 'กขคงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรลวศษสหฬอฮ'.split('');
      } else {
        this.chars = null;
      }
    },
  },
  computed: {
    makerOptions() {
      let opts = {};
      if (this.gameType == 'crossword' || this.gameType == 'wordsearch') {
        opts.sizeInt = this.tableSize;
      }
      opts.mode = this.dialogMode;
      return opts;
    },
    currentGameMaker() {
      if (this.gameType == 'memorygame') {
        return 'memory-game-maker';
      } else if (this.gameType == 'crossword') {
        return 'crossword-puzzle-maker';
      } else {
        return 'word-search-puzzle-maker';
      }
    },
  },
  mounted() {},
  methods: {
    onGameReady(val) {
      this.gameReady = val;
    },
    async closeDialog() {
      this.gameType = null;
      this.$emit('onClose');
    },
    validationForm() {
      let valid = true;

      if (this.question == '' || this.question == null) {
        valid = false;
        return false;
      }

      if (this.gameType == 'memorygame') {
        // console.log(this.question, this.answerLength);
        if (this.answerLength < 2) {
          valid = false;
        }
      } else {
        if (this.answerLength < 1) {
          valid = false;
        }
      }

      console.log(valid, this.gameReady);

      return valid && this.gameReady;
    },
    addRowAnswer: function () {
      this.answer.push({ text: '' });
      // console.log(this.answer[0])
    },
    removeRow: function (index) {
      console.log('row' + index, this.answer.length);
      console.log(this.answer);
      console.log(this.answer_correct, index);
      // this.rows.$remove(index);
      if (this.answer.length > 1) {
        if (this.answer_correct === index) {
          this.answer_correct = 0;
        } else if (this.answer_correct > index) {
          this.answer_correct = this.answer_correct - 1;
        }
        this.answer.splice(index, 1);
      }
    },
    async saveGameData() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        //#region insert choices
        // console.log(this.$refs.gameMaker);
        const gameBody = this.$refs.gameMaker.getGameBody();
        console.clear();
        console.log(gameBody);
        let arrChoiceId = [];
        if (this.gameType == 'memorygame') {
          for (var i = 0; i < gameBody.config.length; i++) {
            if (this.gameType == 'memorygame') {
              //#region memory game
              //#region upload image
              let reqUploads = [];
              let imgPairs = gameBody.config[i].imgs.filter(
                (x) => x.file != null
              );
              for (let img of imgPairs) {
                reqUploads.push(this.uploadImage(img.file));
              }

              let uploadPairedImg = [];

              if (reqUploads.length > 0) {
                let respImgs = await Promise.all(reqUploads);
                if (respImgs != null && respImgs.length > 0) {
                  // image has been uploaded
                  uploadPairedImg = respImgs.map((resp) => resp.data.result);
                } else {
                  // can not upload image
                  alert('Can not upload images');
                  return;
                }
              }
              //#endregion

              if (gameBody.config[i]._id) {
                // update case
                if (reqUploads.length == 1) {
                  if (gameBody.config[i].imgs[0].file != null) {
                    // change first file then check is single file?
                    if (gameBody.config[i].single === true) {
                      // is single file then duplicate img id to second element
                      uploadPairedImg.push(uploadPairedImg[0]);
                    } else {
                      // dothing with second file
                      uploadPairedImg.push(gameBody.config[i].imgs[1]._id);
                    }
                  } else {
                    // change second file (upload)
                    uploadPairedImg = [
                      gameBody.config[i].imgs[0]._id,
                      uploadPairedImg[0],
                    ];
                  }
                } else if (reqUploads.length == 2) {
                  // do nothing
                } else {
                  // not change file
                  uploadPairedImg = gameBody.config[i].imgs.map((x) => x._id);
                }
                let params = {
                  id: gameBody.config[i]._id,
                  memory_game: {
                    single: gameBody.config[i].single,
                    images: uploadPairedImg,
                  },
                };
                let result = await updateChoice(params);
                arrChoiceId.push(result._id);
              } else {
                // insert case
                if (gameBody.config[i].single === true) {
                  // is single file then duplicate img id to second element
                  uploadPairedImg.push(uploadPairedImg[0]);
                }
                let params = {
                  memory_game: {
                    single: gameBody.config[i].single,
                    images: uploadPairedImg,
                  },
                };
                let result = await insertChoice(params);
                arrChoiceId.push(result._id);
              }
              //#endregion
            }
          }
        } else {
          // crossword and worsearch not have choice, just insert table grid and correct to question object
        }
        //#endregion

        //#region insert/update question
        let question = {
          idexam: this.examId,
          typeQuestion: this.gameType,
          question: this.question,
          choices: arrChoiceId,
          randomChoice: gameBody.isRandom,
          randomLimit: gameBody.randomLimit,
          puzzleGridSize: gameBody.puzzleGridSize || 0,
          video: this.video_id,
          audio: this.audio_id,
          score: gameBody.score || 0,
        };

        // insert array score of word list
        if (this.gameType == 'crossword' || this.gameType == 'wordsearch') {
          question.questionGrid = gameBody.config.letterTable;
          question.correctPuzzleGrid = gameBody.config.wordList;
          question.arrayScore = gameBody.arrayScore;
        }

        if (this.articleId) {
          question.articleQuestion = this.articleId;
        }
        console.log(question);
        if (this.questionId) {
          let resultQuestion = await updateQuestion({
            id: this.questionId,
            ...this.oldQuestion,
            ...question,
          });
          console.log(resultQuestion);
          if (resultQuestion) {
            this.loading = false;
            this.dialogSuccess = true;
          }
        } else {
          let resultQuestion = await insertQuestion(question);
          if (resultQuestion) {
            this.loading = false;
            this.dialogSuccess = true;
          }
        }

        // clear data
        this.gameReady = {};
        this.closeDialog();
        //#endregion
      } else {
        console.log('not pass');
        this.dialogSaveFail = true;
      }
    },
    async closeDialogQuestion() {
      this.warnningToSaveDialog = true;
    },
    confirmCloseDialog() {
      this.warnningToSaveDialog = false;
      this.closeDialog();
    },

    uploadImage(file) {
      let formData = new FormData();
      formData.append('fileupload', file);
      formData.append('title', file.name);
      let req = axios.post(
        `${domain}/uploadfile/private/image/puzzle`,
        formData,
        {
          headers: {
            ...headersWithTokenForImage(),
          },
        }
      );

      return req;
      // return new Promise((resolve, reject) => {

      //   .then(async (response) => {
      //     await this.imageUploadId.push(response.data.result);
      //     let imgUrl = await getPrivateImage(response.data.result);
      //     await this.list.push({ src: imgUrl });
      //   })
      //   .catch((e) =>{
      //     console.log("FAILURE!!", e);
      //     reject(e);
      //   });
      // });
    },
    checkMinScore() {
      if (this.question_score < 0) this.question_score = 0;
    },
    async closeMediaDialog() {
      this.mediaDialog = false;
      //this.registerTutoralert = true;
    },
    setVideo(data) {
      console.log(data);
      this.video_id = data;
      this.getPreview('video');
    },
    setAudio(data) {
      this.audio_id = data;
      this.getAudioPreview();
    },
    async getAudioPreview() {
      this.audio_url = await getPrivateFile(this.audio_id);
      if (this.audio_url) {
        this.isCheckComplete = true;
        this.audioPlaying = true;
      }
    },
    async getPreview(type) {
      let resultLink = await getPrivateVideo(
        type == 'audio' ? this.audio_id : this.video_id
      );
      if (resultLink.isCheckComplete !== undefined) {
        this.isCheckComplete = resultLink.isCheckComplete;
        if (resultLink.isCheckComplete) {
          console.log('type == "audio"');
          type == 'audio'
            ? (this.audio_url =
                resultLink.urllocalhost +
                `?token=${localStorage.getItem(
                  'x-session-token'
                )}&server=${serverName}`)
            : this.playerOptions.sources[0].src =
                resultLink.url
          this.audioPlaying = true;
        } else {
          type == 'audio'
            ? (this.audio_url =
                resultLink.urllocalhost +
                `?token=${localStorage.getItem(
                  'x-session-token'
                )}&server=${serverName}`)
            : this.playerOptions.sources[0].src =
                resultLink.urllocalhost
          this.audioPlaying = true;
          console.log('set', this.audioPlaying);
          console.log('this.audio_url', this.audio_url);
        }

        //this.urlVideo = `https://fleet.byteark.com/player?url=${resultLink}`;
        // this.successUpload = true;
        // this.pendingUpload = false;
      }
    },
    deletemedia(type) {
      type == 'audio' ? (this.audio_id = null) : (this.video_id = null);
    },
    openMediaDialog(type) {
      type == 'audio' ? (this.mediaType = 'audio') : (this.mediaType = 'video');
      this.mediaDialog = true;
    },
  },
};
</script>

<style >
.rowContentmange {
  border-style: solid;
  border-radius: 15px;
  border-color: rgb(195, 195, 195);
  border-right-width: thin;
  border-top-width: thin;
  border-left-width: thin;
  border-bottom-width: thin;
}
.lecture-card {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}
.multi-form .btn-style {
  margin-left: 120px;
  margin-right: 120px;
}
.multi-form .btn-add-style {
  margin-left: 45px;
  margin-right: 45px;
}
.multi-form .card-style:focus {
  border-color: #1976d2;
  box-shadow: 0 0 3px 0px #1976d2;
  /* background-color: white; */
  background-color: #1976d2;
}
.multi-form .editor_answer .ql-container {
  min-height: 90px;
}
.multi-form .textField {
  width: 100%;
}

.multi-form .editor .ql-container {
  min-height: 150px;
}
/* .single-form .widthRow {
  width: 98%;
} */
@media only screen and (max-width: 1024px) {
  /* .v-card__text.dialogStyle {
    width: 100%;
    margin: 0 auto;
  } */
  .multi-form .btn-style {
    margin-left: 60px;
    margin-right: 60px;
  }
  .multi-form .btn-add-style {
    margin-left: 22.5px;
    margin-right: 22.5px;
  }
  .multi-form .card-padding {
    padding: 20px;
  }
}
</style>
<style scoped>
.text-primary {
  color: rgb(66, 154, 216) !important;
}
.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.upload-btn-wrapper input[type='file'] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.upload-btn-wrapper input[type='file']:hover {
  cursor: pointer;
}
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 170px !important;
}
.btn-choose {
  color: rgba(0, 0, 0, 0.65);
  background-color: white;
  padding: 8px 20px;
  font-size: 16px;
  width: 170px !important;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
}
</style>